<template>
  <MobileContainer :class="$style.accountEditor">
    <MobileHeader slot="header"
                  :disabled-confirm-btn="profileUpdate"
                  :close-to="redirectIfCancel"
                  :show-confirm-btn="!isNewAccount"
                  nav-action="back"
                  @confirmed="updateUserProfile">
      {{ title }}
    </MobileHeader>

    <CreateAccount :class="$style.accountEditorForm"
                   :update="profileUpdate"
                   :create="profileCreate"
                   @update-complete="updateUserProfileCompleted"
                   @create-complete="createUserProfileCompleted" />

    <MobileButton v-if="isNewAccount"
                  slot="footer"
                  :class="$style.saveButton"
                  :disabled="profileCreate"
                  @click="createUserProfile"
    >
      Save
    </MobileButton>

    <!-- Modal create profile complete -->
    <MobileModal v-model="showProfileCreated"
                 dialog
                 center-content>
      <MobileConfirmDialog title="Account Created"
                           confirm-text="Let's Go"
                           cancel-disabled
                           @confirm="goToLogin()">
        Great! Your account has been created.
      </MobileConfirmDialog>
    </MobileModal>
    <!-- / Modal create profile complete -->

    <LoadingSpinner v-if="isLoading"/>
  </MobileContainer>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import MobileContainer from '@/apps/mobile/components/MobileContainer';
import MobileHeader from '@/apps/mobile/components/MobileHeader';
import CreateAccount from '@/components/CreateAccount';
import MobileButton from '@/apps/mobile/components/MobileButton';
import MobileModal from '@/apps/mobile/components/MobileModal';
import MobileConfirmDialog from '@/apps/mobile/components/MobileConfirmDialog';
import { Action } from 'vuex-class';
import { CART_PREPARE_ORDER } from '@/apps/cart/store/types';
import LoadingMixin from '@/lib/mixins/loading-mixin';
import LoadingSpinner from '@/apps/configurator/components/LoadingSpinner';

/**
 * Mobile user account editor.
 */
@Component({
  components: {
    LoadingSpinner,
    MobileHeader,
    MobileContainer,
    CreateAccount,
    MobileButton,
    MobileModal,
    MobileConfirmDialog,
  },
  mixins: [
    LoadingMixin,
  ],
  props: {
    checkoutAfterLogin: {
      type:    Boolean,
      default: false,
    },
  },
})
export default class MobileUserAccountEditor extends Vue {
  @Action(CART_PREPARE_ORDER) prepareOrder;

  profileUpdate = false;
  profileCreate = false;
  userData = {};

  /**
   * Show profile created dialog.
   */
  showProfileCreated = false;

  get isNewAccount() {
    return this.$route.meta.isNewAccount;
  }

  get redirectIfCancel() {
    return this.$route.meta.redirectIfCancel;
  }

  get title() {
    return this.$route.meta.title || 'Edit Profile';
  }

  /**
   * Update user profile.
   */
  updateUserProfile() {
    this.profileUpdate = true;
  }

  /**
   * Create user profile.
   */
  createUserProfile() {
    this.profileCreate = true;
  }

  /**
   * Update user profile complete.
   * @param {Boolean} success - update complete status success or not.
   */
  updateUserProfileCompleted(success) {
    this.profileUpdate = false;
    if (success) {
      this.$router.push({ name: 'user-profile' });
    }
  }

  /**
   * Create user profile complete.
   * @param {Boolean} success - create complete status success or not.
   * @param userData.
   */
  createUserProfileCompleted([ success, userData ]) {
    this.profileCreate = false;
    if (success) {
      this.userData = userData;
      this.showProfileCreated = true;
    }
  }

  /**
   * Go to login page.
   */
  async goToLogin() {
    if (this.checkoutAfterLogin) {
      try {
        this.loadingStart();
        await this.prepareOrder({ userData: this.userData });

        return this.$router.push({ name: 'payment-confirm', query: { backPage: 'menu' } });
      } catch (e) {
        return this.$router.push({ name: 'mobile-main' });
      } finally {
        this.loadingStop();
      }
    }

    return this.$router.push({ name: 'mobile-main' });
  }
}
</script>

<style lang="scss" module>
@import '@/style/variables.scss';
@import '@/style/helpers.scss';

.accountEditor {
  background: $mobile-gray-bg;

  .accountEditorForm {
    background: transparent;
  }
}

.mainLogo {
  display: block;
  margin: 55px auto;
  height: 169px;
  width: 169px;
}

.text {
  margin: auto;
  color: $black;
  font-family: $main-font-family;
  font-size: rem(15px);
  font-weight: 300;
  letter-spacing: rem(-0.21px);
  text-align: center;
  max-width: 250px;
}

.saveButton {
  margin: 0;
}

</style>



// WEBPACK FOOTER //
// src/apps/mobile/components/MobileUserAccountEditor.vue